import { useEffect } from 'react';
//components
import { Countdown } from 'features/closed/components';
import { Text, Heading } from 'components';
import { Image, Stack, Container, Box } from '@telescope/cassini-ui';
// helpers
import { TRACKING_ROUTES } from 'utils';
import { APP_MAX_WIDTH } from 'utils';
import TagManager from 'react-gtm-module';
import { useWidget } from '@telescope/cassini-hooks';
import { Closed } from 'types';

export const ClosedPage = () => {
  const { data: closedData  } = useWidget({ select: (data: Closed) => data.snapshot.snapshot_views.closed });
  const { content } = closedData!;
  const { data: countdownData } = useWidget({ select: (data:any) => data.snapshot.snapshot_views.countdown });
  const { content: countdownContent, settings: countdownSettings } = countdownData!;
  
  useEffect(() => {
    TagManager.dataLayer({ dataLayer: { event: "pageView", pageTitle: TRACKING_ROUTES.WINDOW }});
  }, []);

  return (
    <Container as={Stack} spacing={12} pb={12} flexGrow={2} textAlign="center" maxW={{ lg: APP_MAX_WIDTH.TABLET }}>   
      <Image src={content.image.src} alt={content.image.alt}/>
      
      <Box>
        <Heading as="h1" size="2xl" allowMarkdown> 
          {content.headline} 
        </Heading>

        <Text allowMarkdown size="lg"> 
          {content.description} 
        </Text> 
      </Box>     

        <Countdown content={countdownContent} settings={countdownSettings} />
      </Container>
    )
};
